const VersionSync = (): JSX.Element | null => {
  const versionKey = 'versionId';
  const currentVersion = '1.0';
  const savedVersion = localStorage.getItem(versionKey);

  if (currentVersion !== savedVersion) {
    localStorage.clear();
    localStorage.setItem(versionKey, currentVersion);
  }

  return null;
};

export default VersionSync;
